import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MotivosNoAdmision } from '../../domain/model/maestro/entity/motivos-no-admision.model';
import { Valoracion } from '../../domain/model/maestro/entity/valoracion.model';
import { Admision } from '../../domain/model/remision/entity/admision.model';
import { PlanManejo } from '../../domain/model/remision/entity/plan-manejo/plan-manejo.model';
import { RemisionAdmision } from '../../domain/model/remision/entity/remision-admision.model';
import { RemisionGatewayAbstract } from '../../domain/model/remision/gateway/remision-gateway.abstract';
import { UsuarioService } from "../../shared/services/usuario.service";
import { anexoRemisionRequest } from '../request-model/remision/anexos.remisiones.request';
import { ConsultarRemisionesFurRequest } from '../request-model/remision/consultar-remisiones-fur.request';
import { FiltrosInformeRemisionesRequest } from '../request-model/remision/filtros-informe-remisiones.request';
import { FiltrosRemisionesRequest } from '../request-model/remision/filtros-remisiones.request';
import { Paciente } from '../../domain/model/remision/entity/paciente.model';
import { Diagnostico } from '../../domain/model/remision/entity/diagnostico.model';
import { DatosRemision } from '../../domain/model/remision/entity/datos-remision.model';
import { Documento, DocumentoDescarga } from '../../domain/model/remision/entity/document.model';


@Injectable()
export class RemisionService extends RemisionGatewayAbstract {


  private readonly url: string;
  private readonly port: string;

  constructor(private readonly http: HttpClient,
    private readonly usuarioService: UsuarioService
  ) {
    super();
    this.url = `${environment.apiBaseUrl}`;
    this.port = `${environment.portBaseUrl}`;
  }

  public generarRemision(): Observable<any> {
    const url = `${this.url}${this.port}/api_ingreso/remision/crearNuevaRemision`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  public consultarEstadoActualRemisionPorIdRemisionYUsuario(idRemision: string, usuario: string, estado?: string): Observable<any> {
    const url = `${this.url}${this.port}/api_ingreso/remision/consultarEstadoActualRemisionPorIdRemisionYUsuario/${idRemision}/${usuario}/${estado}`;
    return this.http.get<any[]>(url, { withCredentials: true });
  }

  public modificarBloqueoRemision(idRemision: string, bloqueo: boolean): Observable<any> {
    const URL = `${this.url}${this.port}/api_ingreso/remision/modificarBloqueoRemision/${idRemision}/${bloqueo}`;
    return this.http.post<void>(URL, null, { withCredentials: true });
  }
  public guardarRemision(data: any): Observable<any> {
    const URL = `${this.url}${this.port}/api_ingreso/remision`;
    return this.http.post<void>(URL, data, { withCredentials: true });
  }

  public asigarEstadoEmpalme(idRemision: string): Observable<any> {
    const URL = `${this.url}${this.port}/api_ingreso/remision/empalme/${idRemision}`;
    return this.http.post<void>(URL, null, { withCredentials: true });
  }


  public admitir(data: any): Observable<any> {
    if (data.admision !== null && data.admision !== undefined) {
      data.paciente.embarazada = data.admision.embarazada ? 'S' : 'N';
      data.paciente.oxigenoDependiente = data.admision.oxigenoDependiente ? 'S' : 'N';
    }
    else {
      data.paciente.embarazada = 'N';
      data.paciente.oxigenoDependiente = 'N';
    }

    const URL = `${this.url}${this.port
      }/api_ingreso/admitir`;
    return this.http.post<void>(URL, data, { withCredentials: true });
  }

  public admitirFur(data: any): Observable<any> {
    if (data.admision !== null && data.admision !== undefined) {
      data.paciente.embarazada = data.admision.embarazada ? 'S' : 'N';
      data.paciente.oxigenoDependiente = data.admision.oxigenoDependiente ? 'S' : 'N';
    }
    else {
      data.paciente.embarazada = 'N';
      data.paciente.oxigenoDependiente = 'N';
    }

    const URL = `${this.url}${this.port
      }/api_ingreso/migracion/admitirRemision`;
    return this.http.post<void>(URL, data, { withCredentials: true });
  }

  public getMotivoCancelacion(): Observable<MotivosNoAdmision[]> {
    const url = `${this.url}${this.port}/api_ingreso/maestros/motivosCancelacion`;
    return this.http.get<MotivosNoAdmision[]>(url, { withCredentials: true });
  }

  public getRemisiones(filtroslistaRemisiones: FiltrosRemisionesRequest): Observable<any> {

    const URL = `${this.url}${this.port}/api_ingreso/remision/consultaRemisiones`;
    const operador = 'eq';

    let params = new HttpParams();

    if (filtroslistaRemisiones.tipoIdentificacion != null) {
      params = params.set('tipoIdentificacion', `${operador}:${filtroslistaRemisiones.tipoIdentificacion}`);
    }
    if (filtroslistaRemisiones.numeroIdentificacion != null) {
      params = params.set('numeroIdentificacion', `${operador}:${filtroslistaRemisiones.numeroIdentificacion}`);
    }
    if (filtroslistaRemisiones.ciudadPrincipal != null) {
      params = params.set('ciudadPrincipal', `${operador}:${filtroslistaRemisiones.ciudadPrincipal}`);
    }
    if (filtroslistaRemisiones.institucionRemitente != null) {
      params = params.set('institucionRemitente', `${operador}:${filtroslistaRemisiones.institucionRemitente}`);
    }
    if (filtroslistaRemisiones.estado != null) {
      params = params.set('estado', `${operador}:${filtroslistaRemisiones.estado}`);
    }
    if (filtroslistaRemisiones.planSalud != null) {
      params = params.set('planSalud', `${operador}:${filtroslistaRemisiones.planSalud}`);
    }
    if (filtroslistaRemisiones.remision != null) {
      params = params.set('remision', `${operador}:${filtroslistaRemisiones.remision}`);
    }
    if (filtroslistaRemisiones.fechaInicioRemision != null) {
      params = params.set('fechaInicioRemision', filtroslistaRemisiones.fechaInicioRemision);
    }
    if (filtroslistaRemisiones.fechaFinRemision != null) {
      params = params.set('fechaFinRemision', filtroslistaRemisiones.fechaFinRemision);
    }

    params = params.set('page', filtroslistaRemisiones.page.toString());
    params = params.set('size', filtroslistaRemisiones.size.toString());
    params = params.set('nombreUsuario', this.usuarioService.InfoUsuario.username);

    return this.http.get<any>(URL, { params, withCredentials: true });
  }

  public getRemisionesFur(consultarRemisionesFurRequest: ConsultarRemisionesFurRequest): Observable<any> {

    const URL = `${this.url}${this.port}/api_ingreso/migracion/consulta/${consultarRemisionesFurRequest.ciudadPrincipal}/${consultarRemisionesFurRequest.programa}/${consultarRemisionesFurRequest.piso}/${consultarRemisionesFurRequest.fechaInicioRemision}/${consultarRemisionesFurRequest.fechaFinRemision}`;

    return this.http.get<any>(URL, { withCredentials: true });
  }

  public obtenerPisosFur(): Observable<any> {
    const URL = `${this.url}${this.port}/api_ingreso/migracion/maestros/49`;
    return this.http.get<any>(URL, { withCredentials: true });

  }
  public obtenerProgramasFur(): Observable<any> {
    const URL = `${this.url}${this.port}/api_ingreso/migracion/maestros/53`;
    return this.http.get<any>(URL, { withCredentials: true });


  }

  public migrarRemisionesFur(listaRemisiones: any[]): Observable<any> {
    const URL = `${this.url}${this.port}/api_ingreso/migracion/migrar`;
    return this.http.post<any>(URL, listaRemisiones, { withCredentials: true });
  }

  public gestionarNovedadesActivacion(ciudad: string): Observable<any> {
    const URL = `${this.url}${this.port}/api_novedades/novedad/gestionarNovedadesActivacion`;

    const bodyRequest = {
      usuarioSolicita: "Migracion",
      estadoSolicitudNovedad: "PENDIENTE_GESTION",
      tipoNovedad: "ACTIVACION",
      idCiudad: ciudad
    };
    return this.http.post(URL, bodyRequest);
  }



  public getRemisionesInforme(filtroslistaRemisiones: FiltrosInformeRemisionesRequest): Observable<any> {

    const URL = `${this.url}${this.port}/api_ingreso/remision/informeRemisiones`;
    const operador = 'eq';

    const tipoIdentificacion = `tipoIdentificacion=${operador}:${filtroslistaRemisiones.tipoIdentificacion}&`;
    const numeroIdentificacion = `numeroIdentificacion=${operador}:${filtroslistaRemisiones.numeroIdentificacion}&`;
    const ciudadPrincipal = `ciudadPrincipal=${operador}:${filtroslistaRemisiones.ciudadPrincipal}&`;
    const institucionRemitente = `institucionRemitente=${operador}:${filtroslistaRemisiones.institucionRemitente}&`;
    const estado = `estado=${operador}:${filtroslistaRemisiones.estado}&`;
    const planSalud = `planSalud=${operador}:${filtroslistaRemisiones.planSalud}&`;
    const remision = `remision=${operador}:${filtroslistaRemisiones.remision}&`;
    const nombreUsuario = sessionStorage.getItem('nombreUsuario');
    const nombreUsuarioFiltro = `nombreUsuarioFiltro=${filtroslistaRemisiones.usuario}&`;
    const fechaInicioRemision = `fechaInicioRemision=${filtroslistaRemisiones.fechaInicioRemision}&`;
    const fechaFinRemision = `fechaFinRemision=${filtroslistaRemisiones.fechaFinRemision}&`;

    let parametros = '';

    if (filtroslistaRemisiones.tipoIdentificacion != null) {
      parametros = parametros.concat(tipoIdentificacion);
    }
    if (filtroslistaRemisiones.numeroIdentificacion != null) {
      parametros = parametros.concat(numeroIdentificacion);
    }
    if (filtroslistaRemisiones.ciudadPrincipal != null) {
      parametros = parametros.concat(ciudadPrincipal);
    }
    if (filtroslistaRemisiones.institucionRemitente != null) {
      parametros = parametros.concat(institucionRemitente);
    }
    if (filtroslistaRemisiones.estado != null) {
      parametros = parametros.concat(estado);
    }
    if (filtroslistaRemisiones.planSalud != null) {
      parametros = parametros.concat(planSalud);
    }
    if (filtroslistaRemisiones.remision != null) {
      parametros = parametros.concat(remision);
    }
    if (filtroslistaRemisiones.usuario != null) {
      parametros = parametros.concat(nombreUsuarioFiltro);
    }
    if (filtroslistaRemisiones.fechaInicioRemision != null) {
      parametros = parametros.concat(fechaInicioRemision);
    }
    if (filtroslistaRemisiones.fechaFinRemision != null) {
      parametros = parametros.concat(fechaFinRemision);
    }
    parametros = parametros.concat(`nombreUsuario=${nombreUsuario}`);
    return this.http.get(URL.concat(`?${parametros}`), { responseType: 'text', withCredentials: true });
  }


  getReporteRemision(idRemisionPk: string): Observable<string> {
    const URL = `${this.url}${this.port}/api_ingreso/remision/imprimirRemision/${idRemisionPk}`;
    return this.http.get<string>(URL, { withCredentials: true });
  }


  getagregadoPaciente(idRemisionPk: string): Observable<Paciente> {
    const URL = `${this.url}${this.port
      }/api_ingreso/paciente/consultarPaciente/${idRemisionPk}`;
    return this.http.get<Paciente>(URL, { withCredentials: true });
  }


  getagregadoDatosDeAtencion(idRemisionPk: string): Observable<any[]> {
    const URL = `${this.url}${this.port
      }/api_ingreso/remision/consultarDatosAtencionPacienteRemision/${idRemisionPk}`;
    return this.http.get<any[]>(URL, { withCredentials: true });
  }


  getagregadoRemision(idRemision: string): Observable<any[]> {
    const URL = `${this.url}${this.port}/api_ingreso/remision/consultaRemision/${idRemision}`;
    return this.http.get<any[]>(URL, { withCredentials: true });
  }

  public getAgregadoDiagnostico(idRemision: string): Observable<Diagnostico[]> {
    const URL = `${this.url}${this.port}/api_ingreso/diagnostico/consultarDiagnosticos/${idRemision}`;
    return this.http.get<Diagnostico[]>(URL, { withCredentials: true });
  }

  public getAgregadoDiagnosticoEspeciales(idRemision: string): Observable<Diagnostico[]> {
    const URL = `${this.url}${this.port}/api_ingreso/diagnostico/consultarDiagnosticosEspeciales/${idRemision}`;
    return this.http.get<Diagnostico[]>(URL, { withCredentials: true });
  }


  getAgregadoDatosRemision(idRemision: string): Observable<DatosRemision> {
    const URL = `${this.url}${this.port}/api_ingreso/datosRemision/consultarDatosRemision/${idRemision}`;
    return this.http.get<DatosRemision>(URL, { withCredentials: true });
  }

  getValoraciones(): Observable<Valoracion[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/valoraciones`;
    return this.http.get<Valoracion[]>(URL, { withCredentials: true });
  }

  getValoracionesPorTipo(tipo: string): Observable<Valoracion[]> {
    const URL = `${this.url}${this.port}/api_ingreso/maestros/valoraciones/${tipo}`;
    return this.http.get<Valoracion[]>(URL, { withCredentials: true });
  }

  getPlanManejoAgregado(idRemision: string): Observable<PlanManejo> {
    const URL = `${this.url}${this.port}/api_ingreso/remision/consultarPlanManejo/${idRemision}`;
    return this.http.get<PlanManejo>(URL, { withCredentials: true });
  }


  public getAdmisionAgregado(idRemision: string): Observable<Admision> {
    const URL = `${this.url}${this.port}/api_ingreso/admision/consultarAdmision/${idRemision}`;
    return this.http.get<Admision>(URL, { withCredentials: true });
  }


  public cargarAnexo(request: anexoRemisionRequest): Observable<string> {
    const URL = `${this.url}${this.port}/api_ingreso/documentosP8/guardarDocumento`;
    return this.http.post<string>(URL, request, { withCredentials: true });
  }


  public consultarDocumentosPorRemisionYdocumento(idRemision: string, tipoDocumento: string, codigoSura: string, documento: string): Observable<Documento[]> {
    const URL = `${this.url}${this.port}/api_ingreso/documentosP8/consultarDocumentosPorRemisionYPaciente/${idRemision}/${tipoDocumento}/${codigoSura}/${documento}`;
    return this.http.get<Documento[]>(URL, { withCredentials: true });
  }


  public consultarDocumentoPorId(idDocumento: string): Observable<DocumentoDescarga> {
    const URL = `${this.url}${this.port}/api_ingreso/documentosP8/consultarDocumentoPorId`;
    const PARAMS = this.setParams(idDocumento);
    return this.http.get<DocumentoDescarga>(URL, { params: PARAMS, withCredentials: true });
  }

  private setParams(idDocumento: string) {
    return new HttpParams().set('idDocumento', idDocumento);
  }

  public verificarPacienteRemisionesActivas(tipoIdentificacion: string, numeroIdentificacion: string, tipoAtencion: number): Observable<boolean> {
    const url = `${this.url}${this.port}/api_ingreso/remision/crearRemision/${tipoIdentificacion}/${numeroIdentificacion}/${tipoAtencion}`;
    return this.http.get<boolean>(url, { withCredentials: true }).pipe();
  }

  public consultarRemisionesAdmitidas(tipoIdentificacion: string, identificacion: string): Observable<RemisionAdmision[]> {
    const URL = `${this.url}${this.port}/api_ingreso/remision/remisionesAdmitidas/${tipoIdentificacion}/${identificacion}`;
    return this.http.get<RemisionAdmision[]>(URL);
  }

}
